import { Stack } from "@mui/material";

const DatagridActions = ({ children }) => (
  <Stack
    direction="row"
    spacing={2}
    flexWrap="nowrap"
    useFlexGap
    justifyContent="flex-end"
    sx={{ width: "100%", whiteSpace: "nowrap" }}
  >
    {children}
  </Stack>
);

export default DatagridActions;
